import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NgxSpinnerService } from 'ngx-spinner';

import {
  FormModeEnum,
  TableActionParams,
  NotificationService,
  ModalService,
  BackendService,
} from 'beyond-util';
import { SifarnikBase } from '../sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { FormName } from '../../../enums/form-name.enum';
import { FormCode } from '../../../enums/form-code.enum';

@Component({
  selector: 'app-nacin-obracuna',
  templateUrl: './nacin-obracuna.component.html',
})
export class NacinObracunaComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private _subscriptions: Array<Subscription> = [];
  private _data: Array<any>;
  public showDetails = false;

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _rtsBackendService: RtsBackendService,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      super.ngOnInit();
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  changeName() {
    if (typeof this.order === 'undefined') {
      return;
    }

    if (this.order.hasOwnProperty('naziv')) {
      this.name = this.order.naziv;
    } else if (this.mode === FormModeEnum.Add) {
      this.name = 'Novi način obračuna';
    } else if (this.order.hasOwnProperty('id')) {
      this.name = 'Način obračuna';
    }
  }

  loadSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSUGO_NO,
          FormName.SifarnikNacinaObracuna,
          EndpointTypes.AllEntities,
          this.filterQuery
        )
        .subscribe(data => {
          this._spinner.hide();

          if (!this.settingsTable) {
            this.alterSettings(data['Settings']);
            this.setSettings(data['Settings']);
          }
          this._data = data['ServiceData'];
          this.setAllFields();
          this.refreshTable();
        })
    );
  }

  alterSettings(settings) {
    settings.additable = false;
    settings.deletable = false;
    settings.editable = false;
    settings.inlineAdding = false;
    settings.inlineEditing = false;
  }

  refreshTable() {
    const data = {
      documentId: 'NacinObracuna',
      result: this._data,
      pageSize: 10,
      pageNumber: 1,
      count: this._data.length,
      menuCalled: false,
      error: 0,
    };

    this._data.forEach(d => (d.id = d.Id));
    this._data.forEach(d => (d.rbr = d.Id));

    this.orderListCount = data.count;
    this.orderList = data.result;
  }

  addOrder() {
    const payload = { ...this.order };
    this._subscriptions.push(
      this._rtsBackendService
        .save(FormCode.MSUGO_NO, FormName.SifarnikNacinaObracuna, payload)
        .subscribe(() => {
          this.changeMode(FormModeEnum.Table);
          this.loadSettings();
        })
    );
  }

  updateOrder() {
    this.order.rbr = this.order.Id;
    const payload = { ...this.order };
    this._subscriptions.push(
      this._rtsBackendService
        .update(FormCode.MSUGO_NO, FormName.SifarnikNacinaObracuna, payload)
        .subscribe(() => {
          this.changeMode(FormModeEnum.Table);
          this.loadSettings();
        })
    );
  }

  onDeleteConfirm() {
    this._subscriptions.push(
      this._rtsBackendService
        .delete(
          FormCode.MSUGO_NO,
          FormName.SifarnikNacinaObracuna,
          this.order.id
        )
        .subscribe(() => {
          this._notificationService.openNoty('Uspešno brisanje');
          this.changeMode(FormModeEnum.Table);
          this.loadSettings();
        })
    );
  }

  onTableActionUpdate(event: TableActionParams) {
    super.onTableActionUpdate(event);
    this.updateOrder();
  }

  onTableInlineSave() {
    this.addOrder();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/nacin-obracuna/nacin-obracuna.component.ts